import './PhilosophySkeleton.scss';

const PhilosophySkeleton = () => {

    return (
        <>
            <div className='careers__philosophy__section__skeleton'>
                <div className='left__side__philosophy__section__skeleton'>
                    <div className='left__side__philosophy__section__title__skeleton'></div>
                    <div className='left__side__philosophy__section__wrapper__skeleton'>
                        {[...Array(4)].map((_, index) => (
                            <div key={index} className='left__side__philosophy__section__item__skeleton'>
                                <div className='left__side__philosophy__section__item__subtitle__skeleton'></div>
                                <div className='left__side__philosophy__section__item__text__skeleton'></div>
                                <div className='left__side__philosophy__section__item__text__skeleton--primary'></div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className='right__side__philosophy__section__skeleton'></div>
            </div>
        </>
    );
};

export default PhilosophySkeleton;